import type { DnaData } from "../../models/Dna.d.ts";
import CodyPreset from "../../_const/trip/CodyPreset.ts";
import type { CodyPreset as CodyPresetT } from "../../_const/trip/CodyPreset.ts";
import HowDoYouLikeToTravel from "../../_const/dna/HowDoYouLikeToTravel.ts";
import type { HowDoYouLikeToTravel as HowDoYouLikeToTravelT } from "../../_const/dna/HowDoYouLikeToTravel.ts";
import WhatMakesGreatTripForYou from "../../_const/dna/WhatMakesGreatTripForYou.ts";
import WhatShouldAvoidWhenPlanning from "../../_const/dna/WhatShouldAvoidWhenPlanning.ts";

const paceLean: Record<HowDoYouLikeToTravelT, number> = {
  [HowDoYouLikeToTravel.SLOW_AND_RELAXED]: -2,
  [HowDoYouLikeToTravel.BALANCED]: 0,
  [HowDoYouLikeToTravel.BUSY_AND_ACTIVE]: 1,
  [HowDoYouLikeToTravel.NON_STOP_ADVENTURE]: 2,
};

const relaxedLeaningInterests: string[] = [
  WhatMakesGreatTripForYou.RELAXED_LEISURE,
  WhatMakesGreatTripForYou.WELLNESS,
];

const activeLeaningInterests: string[] = [
  WhatMakesGreatTripForYou.ADVENTURE,
];

const relaxedLeaningAvoidances: string[] = [
  WhatShouldAvoidWhenPlanning.PACE_AND_TIMING,
  WhatShouldAvoidWhenPlanning.EARLY_MORNINGS,
];

export default function resolvePacePreset(dna?: DnaData | null): CodyPresetT {
  if (!dna) return CodyPreset.MAKE_MORE_RELAXED;

  const interests = dna.what_makes_great_trip_for_you ?? [];
  const avoidances = dna.what_should_avoid_when_planning ?? [];

  const statedLean = dna.how_do_you_like_to_travel
    ? paceLean[dna.how_do_you_like_to_travel] ?? 0
    : 0;

  let supportingLean = 0;

  if (interests.some((interest) => relaxedLeaningInterests.includes(interest))) {
    supportingLean -= 1;
  }

  if (interests.some((interest) => activeLeaningInterests.includes(interest))) {
    supportingLean += 1;
  }

  if (avoidances.some((avoidance) => relaxedLeaningAvoidances.includes(avoidance))) {
    supportingLean -= 1;
  }

  const lean = statedLean + Math.max(-1, Math.min(1, supportingLean));

  return lean < 0 ? CodyPreset.MAKE_MORE_ACTIVE : CodyPreset.MAKE_MORE_RELAXED;
}
